import { NgModule } from '@angular/core';
import { DynamicBootstrapComponent } from './component/dynamic-bootstrap/dynamic-bootstrap.component';

@NgModule({
  declarations: [DynamicBootstrapComponent],
  exports: [DynamicBootstrapComponent],
})
export class DynamicBootstrapModule { }
